import { render, staticRenderFns } from "./UpdateContactProperty.vue?vue&type=template&id=df56b3ba&scoped=true"
import script from "./UpdateContactProperty.vue?vue&type=script&lang=js"
export * from "./UpdateContactProperty.vue?vue&type=script&lang=js"
import style0 from "./UpdateContactProperty.vue?vue&type=style&index=0&id=df56b3ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56b3ba",
  null
  
)

export default component.exports